<template>
  <div>
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="slider_img" />
      </el-carousel-item>
    </el-carousel>
    <!-- 盒子 -->
    <!-- <div class="border_parent">
            <el-row :gutter="10">
                <template v-for="(item, index) in projectType">
                    <el-col :xs="12" :sm="12" :md="6" :key="index">
                        <div class="border">
                            <div class="border_img_parent">
                                <img :src="item.img" class="img_border"/>
                            </div>
                            <div class="border_title">{{item.title}}</div>
                            <div class="border_content_one">{{item.content[0]}}</div>
                            <div class="border_content_two">{{item.content[1]}}</div>
                        </div>
                    </el-col>
                </template>
</el-row>
</div> -->
    <!-- 案例展示 -->
    <!-- <div id="案例展示" class="head-label">案例展示</div>
        <div class="case-presentation">
            <CasePresentation />
        </div> -->
    <!-- 手机端商品展示 -->
    <div id="产品微观" class="head-label">Next Drama2介绍</div>
    <div class="product_mobile">
      <el-row>
        <el-col :xs="24" :sm="12">
          <div class="product_mobile_content">
            <div class="product_mobile_title font_size_30">
              {{ products[0].title }}
            </div>
            <div class="product_font_style product_mobile_content_one">
              {{ products[0].content[0] }}
            </div>
            <div class="product_font_style product_mobile_content_two">
              {{ products[0].content[1] }}
            </div>
            <div class="product_font_style product_mobile_content_two">
              {{ products[0].content[2] }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <img :src="products[0].img[0]" class="product_mobile_img" />
          <img :src="products[0].img[1]" class="product_mobile_img" />
        </el-col>
      </el-row>
    </div>
    <!-- 后台管理 -->
    <div class="product_pc">
      <el-row>
        <el-col :xs="24" :sm="12">
          <div class="product_pc_one">
            <div class="product_mobile_title font_size_30">
              {{ manages[0].title }}
            </div>
            <div style="margin-top: 20px" class="product_font_style">
              {{ manages[0].content[0] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[1] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[2] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[3] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[4] }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <img :src="manages[0].img[0]" class="product_pc_img" />
        </el-col>
      </el-row>
    </div>
    <!-- 关于我们-->
    <div id="关于我们" class="about_me head-label">关于我们</div>
    <div style="width: 90%; background-color: #f2f6fc; margin: 10px auto">
      <div style="display: flex; flex-direction: column; width: 100%">
        <p class="about_me_p">{{ company[0] }}</p>
        <p class="about_me_p">{{ company[1] }}</p>
        <p class="about_me_p">{{ company[2] }}</p>
        <p class="about_me_p">{{ company[3] }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import CasePresentation from "@/components/CasePresentation";
export default {
  name: "home",
  components: { CasePresentation },
  data() {
    return {
      sliders: [],
      projectType: [
        {
          img: require("@/assets/icon/网站建设.png"),
          title: "网站建设",
          content: ["H5网站建设", "PC端网站建设"],
        },
        {
          img: require("@/assets/icon/APP开发.png"),
          title: "APP开发",
          content: ["苹果APP开发", "安卓APP开发"],
        },
        {
          img: require("@/assets/icon/小程序开发.png"),
          title: "小程序开发",
          content: ["各平台小程序开发", "无需下载快速启动"],
        },
        {
          img: require("@/assets/icon/小游戏开发.png"),
          title: "小游戏开发",
          content: ["各平台小游戏", "羊了个羊小游戏"],
        },
      ],
      products: [
        {
          img: ["/static/other/1.png", "/static/other/2.png"],
          title: "Next Drama2满足多类用户需求",
          content: [
            "首页分类展示 选择顶部分类可查看对应商品",
            "动态查看用户发布的动态消息，也可对动态进行评论点赞",
            "消息 可以和系统内的主播进行视频语音聊天",
          ],
        },
      ],
      manages: [
        {
          img: ["/static/other/3.png"],
          title: "Next Drama2管理平台",
          content: [
            "系统管理 控制APP的落地页配置和版本配置",
            "用户管理 用户自定义标签，了解用户消费行为",
            "财务管理 实时掌握用户的会员状态",
            "活动推广 实时掌握拉新排行榜",
            "意见反馈 积极处理用户对app的使用体验",
          ],
        },
      ],
      spec: {
        img: require("@/assets/icon/arrow.png"),
        product: [
          {
            img: require("@/assets/icon/需求沟通.png"),
            title: "需求沟通",
            contents: ["注册一键创建店铺", "开启您的专属店铺"],
          },
          {
            img: require("@/assets/icon/UI设计.png"),
            title: "UI设计",
            contents: ["不同业态打造不同风格", "给用户流畅的视觉体验"],
          },
          {
            img: require("@/assets/icon/功能开发.png"),
            title: "功能开发",
            contents: ["多玩法提升品牌知名度", "优惠福利刺激付费转化"],
          },
          {
            img: require("@/assets/icon/功能测试.png"),
            title: "功能测试",
            contents: ["提供专业产品服务", "帮助线下零售业态提升营销"],
          },
          {
            img: require("@/assets/icon/项目交付.png"),
            title: "项目交付",
            contents: ["提供专业产品服务", "帮助线下零售业态提升营销"],
          },
          {
            img: require("@/assets/icon/后期运维.png"),
            title: "后期运维",
            contents: ["提供专业产品服务", "帮助线下零售业态提升营销"],
          },
        ],
      },
      company: [
        "企业从事于：互联网软件开发，微信公众号，小程序，微商城开发，提供技术支持，是所创业型服务研发公司。",
        "核心理念：打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。",
        "团队作风：我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
        "企业精神：以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。",
      ],
      carousel_height: "550px",
    };
  },
  methods: {},
  mounted() {
    this.sliders = [
      {
        img: require("../../static/slider/a1.jpg"),
      },
      {
        img: require("../../static/slider/a2.jpg"),
      },
      {
        img: require("../../static/slider/a3.jpg"),
      },
      {
        img: require("../../static/slider/a4.jpg"),
      },
    ];
  },
  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "550px";
      } else {
        return "250px";
      }
    },
    computeArrowImg() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 450) {
        return require("@/assets/icon/arrow.png");
      } else {
        return require("@/assets/icon/arrow_down.png");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.border_parent {
  width: 90%;
  margin: 20px auto;
}

.slider_img {
  height: 550px;
  width: 100%;
}

.solve {
  margin-top: 30px;
  margin-bottom: 10px;
}

.border {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  height: auto;
  margin: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.border_one {
  margin-left: 0;
}

.border_img_parent {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.head-label {
  font-size: 30px;
  text-align: center;
  margin: 50px 0;
}

.product_mobile_content {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.product_mobile_img {
  width: 50%;
  height: 800px;
  padding-left: 20px;
  box-sizing: border-box;
}

.product_mobile_title {
  font-weight: bold;
  text-align: center;
}

.product_pc_one {
  text-align: center;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.font_size_30 {
  font-size: 1.875em;
}

.product_font_style {
  font-size: 1.125em;
}

.product_pc_img {
  width: 100%;
}

.product_pc_img_div {
  width: 50%;
  float: left;
  display: flex;
  align-items: center;
}

.product_pc {
  display: flex;
  width: 90%;
  margin: 20px auto;
  background: #f2f6fc;
  align-items: center;
  padding: 50px;
  box-sizing: border-box;
}

.product_spec_parent {
  display: flex;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.cooperation_parent {
  display: flex;
  justify-content: center;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.border_spec {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  float: left;
  width: 25%;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px 0;
}

.about_me_p {
  font-size: 1.25em;
  font-weight: normal;
  padding: 0 20px;
  margin: 10px;
}

.border_title {
  font-family: "PingFang SC";
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: bold;
  text-align: center;
}

.border_content_one {
  margin-top: 20px;
  font-size: 1.125em;
  text-align: center;
}

.border_content_two {
  margin-top: 5px;
  font-size: 1.125em;
  margin-bottom: 25px;
  text-align: center;
}

.img_border {
  margin-top: 15px;
  width: 80px;
  height: 80px;
}

.border_spec_inner_one {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70px;

  .icon {
    width: 50px;
    height: 50px;
  }

  .title {
    font-size: 18px;
    font-weight: 600;
    margin-top: 10px;
  }
}

.border_spec_content_one {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  text-align: center;
}

.border_spec_inner_last {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  margin-bottom: 25px;
  text-align: center;
}

.product_mobile {
  width: 90%;
  align-items: center;
  margin: 20px auto;
  background: #f2f6fc;
  padding: 50px;
  box-sizing: border-box;
}

.product_mobile_img_div {
  width: 50%;
  height: auto;
}

.product_mobile_content_one {
  margin-top: 20px;
  text-align: center;
}

.product_mobile_content_two {
  margin-top: 10px;
  text-align: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .slider_img {
    height: 250px;
    width: 100%;
  }

  .border_parent {
    display: flex;
    width: 90%;
    margin: auto;
    height: auto;
    flex-direction: column;
  }

  .border {
    border-radius: 6px;
    border: 1px solid #ebeef5;
    float: left;
    width: 100%;
    height: auto;
    margin: 10px 0 auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    /*background: aquamarine;*/
  }

  .border_img_parent {
    margin-top: 0;
  }

  .product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    height: auto;
    background: #f2f6fc;
    padding: 50px;
    box-sizing: border-box;
  }

  .product_mobile_content {
    width: 100%;
    margin-top: 15px;
  }

  .product_mobile_content_one {
    margin-top: 5px;
  }

  .product_mobile_content_two {
    margin-top: 5px;
  }

  .product_mobile_img_div {
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .product_mobile_img {
    float: left;
  }

  .product_mobile_title {
    font-weight: bold;
  }

  .product_pc_one {
    width: 100%;
    margin-top: 15px;
  }

  .font_size_30 {
    font-size: 1.25em;
  }

  .product_font_style {
    font-size: 1em;
  }

  .product_pc_img {
    height: 280px;
    width: 320px;
  }

  .product_pc_img_div {
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }

  .product_pc {
    display: flex;
    width: 90%;
    height: auto;
    margin: 20px auto;
    background: #f2f6fc;
    flex-direction: column;
    padding: 50px;
    box-sizing: border-box;
  }

  .product_spec_parent {
    display: flex;
    width: 90%;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: auto;
    flex-direction: column;
  }

  .border_spec {
    float: left;
    height: auto;
    margin: 8px;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px 0;
  }

  .border_title {
    font-family: "PingFang SC";
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: bold;
  }

  .border_content_one {
    margin-top: 5px;
    font-size: 1.125em;
  }

  .border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 8px;
  }

  .img_border {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: aqua;*/
    height: 70px;
  }

  .border_spec_content_one {
    margin-top: 5px;
    font-size: 1.125em;
    float: left;
  }

  .border_spec_inner_last {
    /*background-color: bisque;*/
    margin-top: 5px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 8px;
  }
}

.border_spec_img {
  width: 50px;
  padding: 0 20px;
  // height: 55px;
  align-self: center;
}

.case-presentation {
  width: 90%;
  margin: 20px auto;
}
</style>
